import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ffa8e02c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ffa8e02c&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa8e02c",
  null
  
)

export default component.exports